import PropTypes from 'prop-types';
import React from 'react';
import CustomerDetails from './CustomerDetails';
import AdminCustomerDuplicatesList from './AdminCustomerDuplicatesList';
import AdminActionButton from '../../shared/Buttons/AdminActionButton';
import Checkbox from '../../../common/Checkbox';

const AdminCustomerDuplicateForm = ({
  customer,
  duplicate,
  duplicates,
  setDuplicateCustomer,
  survivingCustomer,
  merge,
  cancel,
  setSurviving,
}) => (
  <div>
    <div className="o-flexbox o-flexbox--justify-start o-flexbox--no-wrap">
      <div className="o-flexbox__item--flex-start u-1/3 u-ph-">
        <h5 className="u-mt- u-amp">Customer</h5>
        <CustomerDetails customer={customer} />
      </div>
      <div className="o-flexbox__item--flex-start u-1/3 u-ph-" display-if={duplicate}>
        <h5 className="u-mt- u-amp">Duplicate</h5>
        <CustomerDetails customer={duplicate} />
      </div>
      <div className="o-flexbox__item--flex-start u-1/3 u-ph-" display-if={survivingCustomer}>
        <h5 className="u-mt- u-amp">Result</h5>
        <CustomerDetails customer={survivingCustomer} showDetails={false} />
      </div>
    </div>
    <div display-if={duplicate} className="u-text-center u-mt--">
      <div className="layout u-text-left u-mb">
        <div className="layout__item u-1/3">
          <Checkbox
            label="Survivor"
            name="surviving"
            type="radio"
            checked={survivingCustomer && survivingCustomer.id === customer.id}
            onClick={() => setSurviving(customer.id)}
          />
        </div>
        <div className="layout__item u-1/3">
          <Checkbox
            label="Survivor"
            name="surviving"
            type="radio"
            checked={survivingCustomer && survivingCustomer.id === duplicate.id}
            onClick={() => setSurviving(duplicate.id)}
          />
        </div>
      </div>
      <AdminActionButton onClick={merge} className="c-btn c-btn--small u-mr-" display-if={survivingCustomer}>
        Merge
      </AdminActionButton>
      <AdminActionButton onClick={cancel} className="c-btn c-btn--red c-btn--small">
        Cancel
      </AdminActionButton>
    </div>
    <AdminCustomerDuplicatesList duplicates={duplicates} setDuplicate={setDuplicateCustomer} />
  </div>
);

AdminCustomerDuplicateForm.propTypes = {
  customer: PropTypes.object,
  duplicate: PropTypes.object,
  duplicates: PropTypes.array,
  setDuplicateCustomer: PropTypes.func.isRequired,
  survivingCustomer: PropTypes.func.isRequired,
  merge: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  setSurviving: PropTypes.func.isRequired,
};

AdminCustomerDuplicateForm.defaultProps = {
  customer: {},
  duplicate: null,
  duplicates: [],
};

export default AdminCustomerDuplicateForm;
